// Import hooks
import { useAppSelector } from 'store/hooks';
import { useAuth } from 'components/utilities';

// Import helpers
import { isRetail } from 'helpers/operators';

export const useUserPackets = () => {
	const { isLoading, data: packets } = useAppSelector(({ subscriber }) => subscriber.packets);
	const { isAuth } = useAuth();

	const isPacketsLoaded = isAuth ? !isLoading : true;
	const isAuthWithPackets = isAuth ? Boolean(packets.length) : false;
	const isPlayerAvailable = !isRetail || isAuthWithPackets;

	return {
		isPacketsLoaded,
		isAuthWithPackets,
		isPlayerAvailable,
		packets
	};
};
